<template>
  <div class="">
    <Loading v-if="loadingState" />
    <template v-else>
      <span v-if="sendRegularList.length > 0">
        <b-row
          v-for="(sendRegular, index) in sendRegularList"
          :key="index"
        >
          <b-col
            xl="4"
            sm="6"
            class="py-1 position-relative"
          >
            <v-select
              v-model="sendRegular.criteriaValue"
              :clearable="false"
              :options="criteria"
              :placeholder="$t('SettingPageCard.placeHolder.chooseCriteria')"
              class="per-page-selector-criteria d-inline-block"
              @input="validationComparison('criteria_field', sendRegular)"
            />
            <template v-if="textHelper.length > 0">
              <feather-icon
                v-show="index == sendRegularList.length - 1"
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderMarkIcon('send_regular_criteria_field')"
                icon="HelpCircleIcon"
                class="ml-50 position-absolute"
                style="top: 0"
              />
            </template>
          </b-col>
          <b-col
            xl="3"
            sm="6"
            class="py-1"
          >
            <v-select
              v-model="sendRegular.comparisonValue"
              :clearable="false"
              :options="comparisonList(sendRegular.criteriaValue)"
              :placeholder="$t('SettingPageCard.placeHolder.equals')"
              class="per-page-selector d-inline-block"
              @input="validationComparison('comparison', sendRegular)"
            />
          </b-col>

          <b-col
            xl="3"
            sm="6"
            class="py-1"
          >
            <b-form-group>
              <b-form-input
                v-model="sendRegular.criteria_value"
                :placeholder="$t('SettingPageCard.placeHolder.inputCriteria')"
                @input="editRegularCriteria('criteria_value', sendRegular)"
              />
              <template v-if="textHelper.length > 0">
                <feather-icon
                  v-show="index == sendRegularList.length - 1"
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderMarkIcon('send_regular_criteria_value')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: -2px; right: 0"
                />
              </template>
            </b-form-group>
          </b-col>

          <b-col
            xl="2"
            sm="6"
            class="py-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mr-1"
              @click="removeRegularCriteria(index, sendRegular.uuid)"
            >
              <feather-icon icon="XIcon" />
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="btn-icon"
              @click="addNewRegularCriteria(sendRegular)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-col>
        </b-row>
      </span>

      <ValidationObserver
        v-else-if="(!hideWhenEmpty || showEmptyForm) && enabled"
        ref="form"
      >
        <b-row>
          <b-col
            xl="4"
            sm="6"
            class="py-1 position-relative"
          >
            <ValidationProvider
              #default="{ errors }"
              rules="required"
              :name="$t('SettingPageCard.placeHolder.chooseCriteria')"
            >
              <v-select
                v-model="newRegularList.criteriaValue"
                :clearable="false"
                :options="criteria"
                :placeholder="$t('SettingPageCard.placeHolder.chooseCriteria')"
                class="per-page-selector-criteria d-inline-block"
                @input="validationComparison('criteria_field', newRegularList)"
              />
              <template v-if="textHelper.length > 0">
                <feather-icon
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderMarkIcon('send_regular_criteria_field')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: 0"
                />
              </template>
              <small class="text-danger">
                {{ errors[0] }}
              </small>
            </ValidationProvider>
          </b-col>
          <b-col
            xl="3"
            sm="6"
            class="py-1"
          >
            <ValidationProvider
              #default="{ errors }"
              rules="required"
              :name="$t('SettingPageCard.placeHolder.equals')"
            >
              <v-select
                v-model="newRegularList.comparisonValue"
                :clearable="false"
                :options="comparisonList(newRegularList.criteriaValue)"
                :placeholder="$t('SettingPageCard.placeHolder.equals')"
                class="per-page-selector d-inline-block"
                @input="validationComparison('comparison', newRegularList)"
              />
              <small class="text-danger">
                {{ errors[0] }}
              </small>
            </ValidationProvider>
          </b-col>

          <b-col
            xl="3"
            sm="6"
            class="py-1"
          >
            <b-form-group>
              <ValidationProvider
                #default="{ errors }"
                rules="required"
                :name="$t('SettingPageCard.placeHolder.inputCriteria')"
              >
                <b-form-input
                  v-model="newRegularList.criteria_value"
                  :placeholder="$t('SettingPageCard.placeHolder.inputCriteria')"
                  @input="editRegularCriteria('criteria_value', newRegularList)"
                />
                <template v-if="textHelper.length > 0">
                  <feather-icon
                    v-b-tooltip.hover.v-primary
                    size="16"
                    :title="renderMarkIcon('send_regular_criteria_value')"
                    icon="HelpCircleIcon"
                    class="ml-50 position-absolute"
                    style="top: -2px; right: 0"
                  />
                </template>
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </ValidationProvider>
            </b-form-group>
          </b-col>

          <b-col
            xl="2"
            sm="6"
            class="py-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="btn-icon"
              @click="validationRegularList(newRegularList)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>

      <div
        v-else-if="enabled"
        class="py-1"
      >
        <b-button
          variant="outline-primary"
          size="sm"
          class="d-inline-flex align-items-center"
          @click="showEmptyForm = true"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          {{ $t('SettingPageCard.empty.addFirstCriteria') }}
        </b-button>
      </div>
    </template>
  </div>
</template>

<script>
import { settingsUtilsMixins } from '@/mixins/settingsUtilsMixins'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'RegularCriteria',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [settingsUtilsMixins],
  props: {
    textHelper: Array,
    hideWhenEmpty: { type: Boolean, default: false },
    enabled: { type: Boolean, default: true },
  },

  data() {
    return {
      sendRegularList: [],
      sendRegularListCopy: [],
      sendRegularParamsList: [],
      loadingState: true,
      showEmptyForm: false,
      newRegularList: {
        criteriaValue: '',
        comparisonValue: '',
        criteria_value: '',
        comparison: '',
      },
      limit: 10,
      required,
    }
  },
  async mounted() {
    this.getRegularCriteria()
  },

  methods: {
    getRegularCriteria() {
      this.$useJwt
        .getRegularCriteriaList()
        .then(res => {
          const results = res && res.data && Array.isArray(res.data.results)
            ? res.data.results
            : []
          const regularList = []
          const regularListCopy = []

          results.forEach(element => {
            regularList.push({
              ...element,
              criteriaValue: this.renderCriteria(element.criteria_field),
              comparisonValue: this.renderComparison(element.comparison),
            })

            regularListCopy.push({
              ...element,
              criteriaValue: this.renderCriteria(element.criteria_field),
              comparisonValue: this.renderComparison(element.comparison),
            })
          })

          this.sendRegularList = regularList
          this.sendRegularListCopy = regularListCopy
        })
        .catch(() => {
          this.sendRegularList = []
          this.sendRegularListCopy = []
        })
        .finally(() => {
          this.loadingState = false
        })
    },

    addNewRegularCriteria(value) {
      if (this.sendRegularList.length >= this.limit) {
        // limitMessage
        this.popup(
          this.$t('SettingPageCard.limitMessage', {
            number: this.limit,
          }),
          'danger',
          this.$t('Message.Error'),
          'AlertTriangleIcon',
        )
      } else {
        let newObject = ''
        if (this.sendRegularList.length > 0) {
          newObject = {
            ...value,
            criteria_field: value.criteriaValue.value,
          }
          this.sendRegularList.push(newObject)
        } else {
          newObject = {
            ...value,
            criteria_field: value.criteriaValue.value,
            comparison: value.comparisonValue.value,
          }
        }

        this.$useJwt.addRegularCriteriaList(newObject).then(res => {
          const { data } = res
          this.popup(
            data[this.messageLang],
            'success',
            this.$t('Message.Success'),
            'CheckIcon',
          )

          this.getRegularCriteria()
        })
      }
    },
    removeRegularCriteria(index, uuid) {
      this.$useJwt.deleteRegularCriteriaList(uuid).then(res => {
        const { data } = res

        this.popup(
          data[this.messageLang],
          'success',
          this.$t('Message.Success'),
          'CheckIcon',
        )

        this.sendRegularList.splice(index, 1)

        if (this.sendRegularList.length == 0) {
          this.newRegularList = {
            criteriaValue: '',
            comparisonValue: '',
            criteria_value: '',
            comparison: '',
          }
        }
      })
    },
    validationComparison(params, value) {
      const comparisonList = this.comparisonList(value.criteriaValue)

      const checkComparisonAvailable = comparisonList.find(
        element => element.value == value.comparisonValue.value,
      )

      if (checkComparisonAvailable == undefined) {
        value.comparisonValue = comparisonList[0]

        if (this.sendRegularList.length > 0) this.editRegularCriteria(params, value)
      } else if (this.sendRegularList.length > 0) this.editRegularCriteria(params, value)
    },
    editRegularCriteria(params, value) {
      const newValue = {
        ...value,
        criteria_field: value.criteriaValue.value,
        comparison: value.comparisonValue.value,
      }

      if (this.sendRegularParamsList.length == 0) {
        this.sendRegularParamsList.push(newValue)
        this.$emit('regular', this.sendRegularParamsList)
      } else {
        const getUuid = this.sendRegularParamsList.find(
          element => element.uuid == value.uuid,
        )
        if (getUuid == undefined) {
          this.sendRegularParamsList.push(newValue)
          this.$emit('regular', this.sendRegularParamsList)
        } else {
          getUuid[params] = newValue[params]
          this.$emit('regular', this.sendRegularParamsList)
        }
      }
    },
    validationRegularList(value) {
      this.$refs.form.validate().then(res => {
        if (res) this.addNewRegularCriteria(value)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.per-page-selector-send-method {
  width: 320px;
}

.per-page-selector-criteria {
  width: 100%;
}
.per-page-selector {
  width: 100%;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
